module.exports = __webpack_public_path__ + "static/media/aquecedor4.59256894.png";